import api from "./api";

const roundsService = {
  listByUniversity: (universityId) => api.get(`/rounds/university/${universityId}`).then((r) => r.data),
  create: (universityId, payload) => api.post(`/rounds/university/${universityId}`, payload).then((r) => r.data),
  update: (roundId, payload) => api.put(`/rounds/${roundId}`, payload).then((r) => r.data),
  setStatus: (roundId, is_active) => api.patch(`/rounds/${roundId}/status`, { is_active }).then((r) => r.data),
  assignPanel: (roundId, panel_user_id) => api.post(`/rounds/${roundId}/panel`, { panel_user_id }).then((r) => r.data),
  unassignPanel: (roundId, panelUserId) => api.delete(`/rounds/${roundId}/panel/${panelUserId}`).then((r) => r.data),
  syncApplicants: (roundId) => api.post(`/rounds/${roundId}/sync-applicants`).then((r) => r.data),
    releaseShortlisted: (roundId) =>
    api.post(`/rounds/${roundId}/release-shortlisted`)
      .then((r) => r.data),
};

export default roundsService;